import { ChangeDetectorRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  show: boolean = false;
  splash: boolean = false;
  message: string | null = null;

  constructor() {}

  start(splash?: boolean) {
    this.show = true;
    this.splash = splash ?? false;
  }

  setMessage(message: string | null) {
    this.message = message;
  }

  stop() {
    this.show = false;
    this.splash = false;
    this.message = null;
  }
}
